import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Plus } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  description?: string;
  backLink?: string;
  backLabel?: string;
  actionLink?: string;
  actionLabel?: string;
  actionIcon?: React.ReactNode;
  onActionClick?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  backLink,
  backLabel = 'Retour',
  actionLink,
  actionLabel,
  actionIcon = <Plus size={16} />,
  onActionClick
}) => {
  return (
    <div className="mb-6">
      {backLink && (
        <Link 
          to={backLink}
          className="inline-flex items-center text-sm text-gray-600 hover:text-primary-600 mb-4"
        >
          <ArrowLeft size={16} className="mr-1" />
          {backLabel}
        </Link>
      )}
      
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
        </div>
        
        {(actionLink || onActionClick) && (
          <div className="mt-4 sm:mt-0">
            {actionLink ? (
              <Link
                to={actionLink}
                className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors shadow-sm text-sm font-medium"
              >
                {actionIcon}
                <span className="ml-2">{actionLabel}</span>
              </Link>
            ) : (
              <button
                onClick={onActionClick}
                className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors shadow-sm text-sm font-medium"
              >
                {actionIcon}
                <span className="ml-2">{actionLabel}</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;